import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=95a3f6ca&scoped=true"
import script from "./StickyHeader.vue?vue&type=script&lang=js"
export * from "./StickyHeader.vue?vue&type=script&lang=js"
import style0 from "./StickyHeader.vue?vue&type=style&index=0&id=95a3f6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a3f6ca",
  null
  
)

export default component.exports